import { Col, Row, Image, Menu, Collapse } from 'antd';
import Link from 'next/link';
import { PlusCircleOutlined, MinusCircleOutlined, BookOutlined, QuestionCircleOutlined, FileTextOutlined, MailOutlined } from '@ant-design/icons';
import { useRouter } from "next/router";
import { useState, useEffect, useRef, useMemo } from 'react';
import { useSession } from "next-auth/react";
import UserProfileModal from "../pages/components/UserProfileModal"
import HelpFAQModal from "./HelpFAQModal"
import ComingSoonModal from "./ComingSoonModal"
import Avatar from "react-avatar";
import Modal from 'react-modal';
import styles from '../styles/UserProfile.module.css'
import { useTheme } from "next-themes";

const { Panel } = Collapse;

export default function Sidebar({ sideMenuArrProp }) {
  const { data: session } = useSession();
  const [selectedPath, setSelectedPath] = useState(0);
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sideMenuArr, setSideMenuArr] = useState(() => sideMenuArrProp ?? []);
  const [isModalHelp, setIsModalHelp] = useState(false);
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  const [comingSoonTitle, setComingSoonTitle] = useState('');
  const { theme } = useTheme();
  const [fctLogo, setFctLogo] = useState('/images/FCT.png');
  const mediaQueryRef = useRef(null);
  // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  useEffect(() => {
    let isMounted = true;
    mediaQueryRef.current = window.matchMedia('(prefers-color-scheme: dark)');
    const prefersDarkMode = mediaQueryRef.current.matches;
    if (isMounted) {
      if (theme === 'dark' || prefersDarkMode) {
        setFctLogo('/images/FCT.png')
      } else {
        setFctLogo('/images/FCT.png')
      }
    }
    return () => {
      isMounted = false;
      mediaQueryRef.current = null;
    };
  }, [theme]);

  const openHelpModal = () => setIsModalHelp(true);
  const closeHelpModal = () => setIsModalHelp(false);

  const userRole = session?.user?.roles;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const userNameStyle = { color: 'white', fontWeight: 'bold' };
  const selected = { color: '#22b27e' };
  const unSelected = { color: 'white' };

  const helpItemStyle = {
    display: 'flex', alignItems: 'center', gap: '12px',
    backgroundColor: '#f0f4f8', borderRadius: '8px',
    padding: '10px 12px', marginBottom: '10px',
    textDecoration: 'none', color: 'inherit',
    transition: 'background-color 0.2s ease',
  };
  const futureItemStyle = { opacity: 0.55, cursor: 'not-allowed' };
  const helpIconStyle = { fontSize: '20px', flexShrink: 0 };
  const badgeStyle = {
    marginLeft: '8px', fontSize: '10px',
    backgroundColor: '#e0f0ff', color: '#0c6fad',
    borderRadius: '4px', padding: '2px 6px',
    fontWeight: '500', verticalAlign: 'middle',
  };

  useEffect(() => {
    if (!session) router.push("/");
  }, [session, router]);

  useEffect(() => {
    let isMounted = true;
    if (localStorage.getItem('menubardata') && sideMenuArr.length <= 0) {
      const menuObj = localStorage.getItem('menubardata');
      if (isMounted && menuObj) {
        try {
          const menuBar = JSON.parse(menuObj);
          if (menuBar?.dashboard?.[2]?.sideMenu) {
            setSideMenuArr(menuBar?.dashboard?.[2]?.sideMenu || []);
          }
        } catch (err) {
          console.error('Failed to parse menubardata:', err);
        }
      }
    }
    return () => { isMounted = false; };
  }, [sideMenuArr.length]);

  const handleNavigation = (indexValue) => {
    if (userRole.includes('Admin') || userRole.includes('Internal User') || userRole.includes('Internal Admin')) {
      switch (indexValue) {
        case 0: return '/admin-center/users';
        case 1: return '/admin-center/company';
        case 2: return '/jobs/all-jobs';
      }
    }
  };

  const renderWidget = (indexValue) => {
    const path = handleNavigation(indexValue);
    setSelectedPath(indexValue);
    router.push(path);
  };

  const getIconPath = (path) => {
    if (!path) return null;
    if (path.startsWith('/') || path.startsWith('http')) return path;
    if (path.startsWith('../')) return path.replace('../', '/');
    return `/images/sidebar/${path}`;
  };

  const { groupedMenu, ungroupedMenu } = useMemo(() => {
    const grouped = {};
    const ungrouped = [];
    sideMenuArr.forEach(item => {
      if (item.Group) {
        if (!grouped[item.Group]) grouped[item.Group] = [];
        grouped[item.Group].push(item);
      } else {
        ungrouped.push(item);
      }
    });
    return { groupedMenu: grouped, ungroupedMenu: ungrouped };
  }, [sideMenuArr]);

  return (
    <>
      <div className="main-sidebar">
        <Row align='middle' justify='space-between' className='sidebar-logo'>
          <Col>
            <Image src="/images/FCT.png" alt="Logo" height={40} width={125} preview={false} />
          </Col>
        </Row>

        <div className="sidebar-list">
          <Collapse
            accordion
            bordered={false}
            expandIcon={({ isActive }) => isActive ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
          >
            {Object.entries(groupedMenu).map(([groupName, items]) => {
              const isGroupActive = items.some(item => router.pathname === item.URL);
              return (
                <Panel header={groupName} className={isGroupActive ? 'active-group' : ''} key={groupName}>
                  <ul className="sidebar-list">
                    {items.map((item, index) => (
                      <li key={index} className={router.pathname === item.URL ? 'active' : ''}>
                        <Link legacyBehavior href={item.URL}>
                          <a style={router.pathname === item.URL ? selected : unSelected}>
                            <Image src={item.path} className="img-active" preview={false} style={{ marginRight: '8px' }} alt="" />
                            <Image src={item.path} className="img-default" preview={false} style={{ marginRight: '8px' }} alt="" />
                            <span>{item.Name}</span>
                          </a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Panel>
              );
            })}
          </Collapse>

          <ul className="sidebar-list">
            {ungroupedMenu.map((item, index) => (
              <li key={index} className={router.pathname === item.URL ? 'active' : ''}>
                <Link legacyBehavior href={item.URL}>
                  <a style={router.pathname === item.URL ? selected : unSelected}>
                    <Image src={item.path} className="img-active" preview={false} style={{ marginRight: '8px' }} alt="" />
                    <Image src={item.path} className="img-default" preview={false} style={{ marginRight: '8px' }} alt="" />
                    <span>{item.Name}</span>
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className='sidebarBottom'>
          <Row>
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <Avatar
                  name='?'
                  size="30"
                  onClick={openHelpModal}
                  title='Help'
                  round={true}
                  color=" rgb(12, 63, 107"
                  className='userProfile'
                />
                <span style={userNameStyle}>{session?.user?.roles?.[0] === 'Admin' ? 'Help' : 'Help & Support'}</span>

                {isModalHelp &&
                  <Modal
                    isOpen={isModalHelp}
                    onRequestClose={closeHelpModal}
                    contentLabel="Help"
                    style={{ overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000 } }}
                    className={styles.userProfileModalPopup}
                  >
                    <button className={styles.onRequestClose} onClick={closeHelpModal}><span>&times;</span></button>
                    <div style={{ minWidth: '260px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
                        <span style={{ fontSize: '20px' }}>❓</span>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700' }}>{session?.user?.roles?.[0] === 'Admin' ? 'Help' : 'Help & Support'}</h3>
                      </div>
                      {session?.user?.roles?.[0] !== 'Admin' && (
                        <>
                          <div style={{ ...helpItemStyle, cursor: 'pointer' }}
                            onClick={() => { setIsModalHelp(false); router.push('/help/user-guide'); }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d6eaf8'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f4f8'}>
                            <span style={helpIconStyle}><BookOutlined style={{ color: '#4f46e5' }} /></span>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>User Guides</div>
                              <div style={{ fontSize: '12px', color: '#667085' }}>Documentation &amp; manuals</div>
                            </div>
                          </div>
                          <div style={{ ...helpItemStyle, cursor: 'pointer', opacity: 0.85 }} onClick={() => { setIsFAQOpen(true); setIsModalHelp(false); }}>
                            <span style={helpIconStyle}><QuestionCircleOutlined style={{ color: '#059669' }} /></span>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>FAQs</div>
                              <div style={{ fontSize: '12px', color: '#667085' }}>Frequently asked questions</div>
                            </div>
                          </div>
                          <div style={{ ...helpItemStyle, ...futureItemStyle }} onClick={() => { setComingSoonTitle('Raise a Ticket'); setIsModalHelp(false); }}>
                            <span style={helpIconStyle}><FileTextOutlined style={{ color: '#d97706' }} /></span>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>
                                Raise a Ticket <span style={badgeStyle}>Coming Soon</span>
                              </div>
                              <div style={{ fontSize: '12px', color: '#667085' }}>EVA integration</div>
                            </div>
                          </div>
                          {session?.user?.roles?.[0] !== 'Internal Manager' && session?.user?.roles?.[0] !== 'Internal Admin' && (
                            <div style={{ ...helpItemStyle, cursor: 'pointer' }} onClick={(e) => {
                              e.stopPropagation();
                              const name = localStorage.name || '';
                              const to = 'HRSupport@fourcolorstech.com'.trim();
                              const subject = encodeURIComponent('Support Request');
                              const body = encodeURIComponent(`Hello,\n\n\nThanks & Regards,\n${name}`);
                              const a = document.createElement('a');
                              a.href = `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`;
                              a.target = '_blank';
                              a.rel = 'noopener noreferrer';
                              document.body.appendChild(a);
                              a.click();
                              document.body.removeChild(a);
                              setIsModalHelp(false);
                            }}>
                              <span style={helpIconStyle}><MailOutlined style={{ color: '#dc2626' }} /></span>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Contact Admin</div>
                                <div style={{ fontSize: '12px', color: '#667085' }}>Send mail to HR Support</div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {session?.user?.roles?.[0] === 'Admin' && (
                        <>
                          <div style={{ ...helpItemStyle, cursor: 'pointer' }}
                            onClick={() => { setIsModalHelp(false); router.push('/help/user-guide'); }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d6eaf8'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f4f8'}>
                            <span style={helpIconStyle}><BookOutlined style={{ color: '#4f46e5' }} /></span>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>LMS User Guide</div>
                              <div style={{ fontSize: '12px', color: '#667085' }}>Admin documentation & manuals</div>
                            </div>
                          </div>
                          <div style={{ ...helpItemStyle, cursor: 'pointer' }}
                            onClick={() => { setIsFAQOpen(true); setIsModalHelp(false); }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d6eaf8'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f4f8'}>
                            <span style={helpIconStyle}><QuestionCircleOutlined style={{ color: '#059669' }} /></span>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>FAQs</div>
                              <div style={{ fontSize: '12px', color: '#667085' }}>Admin perspective FAQs</div>
                            </div>
                          </div>
                        </>
                      )}
                      <div style={{ borderTop: '1px solid #ddd', marginTop: '14px', paddingTop: '10px', textAlign: 'center' }}>
                        <div className={styles.PopUpLogo}>
                          <Image src={fctLogo} alt="Logo" height={22} preview={false} />
                        </div>
                        <p style={{ fontSize: '11px', color: '#999', margin: '6px 0 0' }}>EDX Version 2410</p>
                      </div>
                    </div>
                  </Modal>
                }
              </ul>
            </Col>
            <br /><br />
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <Avatar
                  name={localStorage.name ? localStorage.name : ""}
                  size="30"
                  onClick={openModal}
                  round={true}
                  color=" rgb(12, 63, 107"
                  className='userProfile'
                />
                <span style={userNameStyle}>{localStorage.name ? localStorage.name : ""}</span>
                <UserProfileModal
                  isOpen={isModalOpen}
                  onRequestClose={closeModal}
                />
              </ul>
            </Col>
          </Row>
        </div>
      </div>
      <HelpFAQModal isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} isAdmin={session?.user?.roles?.[0] === 'Admin'} />
      <ComingSoonModal isOpen={!!comingSoonTitle} onClose={() => setComingSoonTitle('')} title={comingSoonTitle} />
    </>
  );
}
